// common form fields of roles except patient

import React from "react";
import Grid from "./Grid";
import RhfInput from "./rhfFields/RhfInput";
import RhfSelect from "./rhfFields/RhfSelect";
import RhfPhone from "./rhfFields/RhfPhone";
import RhfCustomDatepicker from "./rhfFields/RhfCustomDatepicker";
import CityStateZipcode from "./CityStateZipcode";
import { US_ORG_TIMEZONE_SELECT_OPTIONS } from "@/constants/usOrgTimezones";

type Props = {
  defaultValues: any;
  isEdit?: boolean;
};

const CommonFormFields = ({ defaultValues, isEdit = false }: Props) => {

  const dissableFields = !isEdit;
  return (
    <>
      <Grid  count={{ sm: 1, md: 3 }} gap={3}>
        <RhfInput
          name="firstName"
          label="First Name"
          required
          isAlphabet
          defaultvalue={defaultValues?.firstName ?? ""}
        />

        <RhfInput
          name="middleName"
          label="Middle Name"
          required={false}
          isAlphabet
          defaultvalue={defaultValues?.middleName ?? ""}
        />

        <RhfInput
          name="lastName"
          label="Last Name"
          required
          isAlphabet
          defaultvalue={defaultValues?.lastName ?? ""}
        />
      </Grid>

      <Grid count={{ sm: 1, md: 3 }} gap={3}>
        <RhfCustomDatepicker
          name="dateOfBirth"
          label="Date of birth"
          required
          isFutureDateDisabled
          placeholder="Select date of birth"
        />
        <RhfInput
          type="email"
          name="email"
          label="Email"
          required
          disabled={dissableFields}
          defaultvalue={defaultValues?.email ?? ""}
        />

        <RhfPhone
          name="phone"
          label="Phone Number"
          required
          defaultvalue={defaultValues?.phone ?? ""}
        />
      </Grid>
      <CityStateZipcode
        count={2}
        gap={3}
        cityName="city"
        stateName="state"
        zipcodeName="zipcode"
        componentBefore={
          <RhfInput
            name="street"
            label="Street"
            required
            defaultvalue={defaultValues?.street ?? ""}
          />
        }
      />
      {/* <Grid count={2} gap={3}>
   
     <RhfInput
      name="city"
      label="City"
      required

    />
     
  </Grid>
  <Grid count={2} gap={3}>
    <RhfInput
      name="state"
      label="State"
      required

    />
     <RhfInput
      name="zipcode"
      label="Zipcode"
      isNumber
      maxLength={5}
      required

    />
  </Grid> */}

      <Grid count={{ sm: 1, md: 2}} gap={3}>
        <RhfSelect
          label="Gender"
          name="gender"
          required
          options={[
            { label: "Male", value: "male" },
            { label: "Female", value: "female" },
            { label: "Prefer not to say", value: "others" },
          ]}
          defaultvalue={defaultValues?.gender ?? ""}
        />

        <RhfSelect
          label="Status"
          name="status"
          required
          options={[{"label": "Active", "value": "active"}, {"label": "Inactive", "value": "inactive"}]}
          defaultvalue={defaultValues?.status ?? "active"} // fallback to active
        />
      </Grid>

      <Grid count={{ sm: 1, md: 2 }} gap={3}>
        <RhfSelect
          label="Timezone"
          name="timezone"
          required
          options={US_ORG_TIMEZONE_SELECT_OPTIONS}
          defaultvalue={defaultValues?.timezone ?? ""}
          placeholder="Select timezone"
        />
      </Grid>
    </>
  );
};

export default CommonFormFields;
